import React, { useCallback } from 'react'
import { Button } from '@mui/material'
import { FormikProps } from 'formik'
import { useAddPatientAsInProgramMutation } from 'src/legacy/lib/graphql/queries.generated'

type ParticipantFormData = {
  firstname: string
  lastname: string
  email: string
  source: string | undefined
  referralName: string
  region: string
  programID: string
  memberID: string | undefined
}

type Props = {
  form: FormikProps<ParticipantFormData>
  onAddParticipantSuccess?: () => void
}

// For development purposes only.
export function CreateAsInProgramButton({ form, onAddParticipantSuccess }: Props) {
  const [addPatientAsInProgramMutation, { loading }] = useAddPatientAsInProgramMutation({
    onCompleted: onAddParticipantSuccess,
  })

  const handleCreateAsInProgram = useCallback(async () => {
    const errors = await form.validateForm()
    if (Object.keys(errors).length > 0) {
      form.setTouched({
        firstname: true,
        lastname: true,
        email: true,
        referralName: true,
        region: true,
        programID: true,
      })
      return
    }

    const { values } = form

    await addPatientAsInProgramMutation({
      variables: {
        email: values.email,
        firstname: values.firstname,
        lastname: values.lastname,
        programID: values.programID,
        region: values.region,
        referralName: values.referralName,
        source: values.source,
        memberID: '00000000',
        phone: '+18888888888',
        birthDate: '2000-01-01',
      },
    })
  }, [addPatientAsInProgramMutation, form])

  return (
    <Button
      type="button"
      variant="outlined"
      onClick={handleCreateAsInProgram}
      size="small"
      disabled={loading || form.isSubmitting}
    >
      INVITE: IN PROGRAM
    </Button>
  )
}
